var Tabs = {
	init: function () {

		$('.konto-page').on('click', '.js-nav-tabs .nav-item a', function(e) {
			e.preventDefault();
			var href = $(this).attr('href');
			window.location.hash=href;
		});

		$('.sign-page').on('click', '.sign-switch .nav-item', function(e) {
			e.preventDefault();
			var href = $(this).attr('href');
			window.location.hash=href;
        });

		$('.sign-page').on('click', '.js-tab-switch-btn', function(e) {
			e.preventDefault();
			var href = $(this).attr('href');
			$('.sign-page .nav-item[href="' + href + '"]' ).trigger('click');
        });

		if(window.location.hash) {
			let selectedTab = window.location.hash;
			$('.konto-page .js-nav-tabs .nav-link[href="' + selectedTab + '"]' ).trigger('click');
			$('.sign-page .nav-item[href="' + selectedTab + '"]' ).trigger('click');
        }

		if(!window.location.hash) {
			// $('.konto-page .nav-item .nav-link[href="#profil"]' ).trigger('click');
			$('.sign-page .nav-item[href="#prihlaseni"]' ).trigger('click');
		}
	}
}

module.exports = Tabs;
